import dayjs from 'dayjs';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';

dayjs.extend(quarterOfYear);

/** @typedef {'this_month' | 'last_month' | 'quarter' | 'year' | 'custom'} DatePresetId */

/**
 * @param {DatePresetId} preset
 * @returns {{ from: import('dayjs').Dayjs, to: import('dayjs').Dayjs }}
 */
export function rangeFromPreset(preset) {
  const now = dayjs();
  switch (preset) {
    case 'this_month':
      return { from: now.startOf('month'), to: now.endOf('month') };
    case 'last_month': {
      const prev = now.subtract(1, 'month');
      return { from: prev.startOf('month'), to: prev.endOf('month') };
    }
    case 'quarter':
      return { from: now.startOf('quarter'), to: now.endOf('quarter') };
    case 'year':
      return { from: now.startOf('year'), to: now.endOf('year') };
    default:
      return { from: now.startOf('month'), to: now.endOf('month') };
  }
}

export const DATE_PRESETS = [
  { id: 'this_month', label: 'This Month' },
  { id: 'last_month', label: 'Last Month' },
  { id: 'quarter', label: 'This Quarter' },
  { id: 'year', label: 'This Year' },
  { id: 'custom', label: 'Custom' },
];
